import ScrollableTableWrapper from 'components/table/components/ScrollableTableWrapper';
import TableSkeleton from 'components/table/components/TableSkeleton';
import Thead from 'components/table/components/thead';
import useText from 'hooks/useText';
import CompanyTableRow from './CompanyTableRow';
import { COMPANY_COLUMNS, COMPANY_COLUMNS_DEFAULT, FIXED_LAST, columnTitle, columnsOfTab } from './companyColumns';

const columnOf = (key) => [...COMPANY_COLUMNS, FIXED_LAST].find((column) => column.key === key);

/**
 * The companies of a tab in the admin's table (ScrollableTableWrapper, Thead,
 * TableRow); without `companies`, grey rows while they are read. `columns`:
 * those chosen (companyColumns), of which the tab shows its own;
 * `sizeThresholds`: those of the list's answer, for the tooltip of a class.
 */
const CompanyTable = ({
  tab,
  columns = COMPANY_COLUMNS_DEFAULT,
  companies,
  busy,
  selectedId,
  team,
  meId,
  onOpen,
  onOpenGroup,
  onAssign,
  sizeThresholds = null,
}) => {
  const { text } = useText('companies');
  const shown = columnsOfTab(columns, tab);
  const header = [
    text('columnCompany'),
    ...shown.map((column) => {
      return column === FIXED_LAST.key ? (
        // The commercial's avatar speaks for itself: no title over it.
        ''
      ) : (
        columnTitle(columnOf(column), text)
      );
    }),
  ];
  return (
    <ScrollableTableWrapper>
      <table className={`w-full table-auto text-gray-500 ft-sm transition-opacity ${busy ? 'opacity-60' : ''}`}>
        <thead className="sticky top-0 z-10">
          <Thead champsHeader={header} pathname="/companies" />
        </thead>
        {companies ? (
          <tbody>
            {companies.map((company, index) => (
              <CompanyTableRow
                key={company._id}
                company={company}
                columns={shown}
                index={index}
                selectedId={selectedId}
                team={team}
                meId={meId}
                onOpen={onOpen}
                onOpenGroup={onOpenGroup}
                onAssign={onAssign}
                sizeThresholds={sizeThresholds}
              />
            ))}
          </tbody>
        ) : (
          // Thead adds an empty column for the actions.
          <TableSkeleton columns={header.length + 1} label={text('loading')} />
        )}
      </table>
    </ScrollableTableWrapper>
  );
};

export default CompanyTable;
